module.exports = __webpack_public_path__ + "static/media/Saint Kitts and Nevis.43141d3b.png";